import { useContext } from 'react';

import { DynamicAssessmentContext } from '../contexts/DynamicAssessmentContext';
import type { ResolvedDynamicAssessmentAnalytics } from '../types/dynamicAssessmentAnalytics';

/**
 * The analytics sink, with every member guaranteed present and identity-stable (see
 * `DynamicAssessmentProvider`), so it's safe in hook dependency arrays. Throws only when there's
 * no provider at all — a provider without `analytics` yields no-ops.
 */
export function useDynamicAssessmentAnalytics(): ResolvedDynamicAssessmentAnalytics {
  const value = useContext(DynamicAssessmentContext);
  if (!value) {
    throw new Error(
      'useDynamicAssessmentAnalytics must be used within a DynamicAssessmentProvider'
    );
  }
  return value.analytics;
}
